<template lang="pug">
div.row
    .col-10(id="proteinBlock")
    .col-2.protein_sequence_legend
        b-form-group.mt-5
            b-form-checkbox(
                v-for="opt in modificationTypes"
                v-model="selectedPtmTypes"
                :key="opt.value"
                :value="opt.value"
                :class="opt.value"
                stacked
                ) {{ opt.text }} ({{ opt.count }})
</template>
<script>
import * as d3 from 'd3'

const colorScheme = [
    '#ff681e',
    '#5a2a82',
    '#3abbba',
    '#1b2944',
    'gray',
    'green',
    'red',
    'black'
]

// TODO move to utils/general
const legendColours = {
    'Artefact': '#45516f',
    'Post-translational': '#ff681e',
    'Chemical derivative': '#3abbbb',
    'Multiple,Post-translational': '#ff681e',
    'Other glycosylation': '#5a2a82',
    'Post-translational,Artefact': '#75eeed',
    'Isotopic label,Multiple': '#8a56b2',
    'Post-translational,Isotopic label': '#ff9a4f',
    'Multiple': '#0095a8',
    'O-linked glycosylation': '#6ff9ff',
    'Chemical derivative,Multiple': '#76d275',
    'N-linked glycosylation': '#00701a',
    'Pre-translational': '#fdd835',
    'Synth. pep. protect. gp.': '#870000',
    'Co-translational': '#bb002f'

}
export default {
    name: 'ProteinSequence',
    data() {
        return {
            // sequence: '',
            seqarray: [],
            // modifications: [],
            xScale: function() {},
            xAxis: '',
            zoom: '',
            svg: '',
            svg2: '',
            // ptmLines: '',
            ptmSites: '',
            proteinseq: '',
            maxPeptideCount: 0,
            chart_width: 0,
            ptmTypes: [],
            ptmMap: {},
            ptmSitesGroup: '',
            modificationsSorted: [],
            modificationTypes: [],
            selectedPtmTypes: ['post_translational', 'chemical_derivative']
        }
    },
    props: {
        sequence: String,
        modifications: Array
    },
    beforeMount: function() {
        this.modificationTypes = this.setModificationTypes(this.modifications)
        this.modificationsSorted = this.modifications.toSorted((a, b) => {
            const a_type = a.modificationType.toLowerCase()
            const b_type = b.modificationType.toLowerCase()
            if(a_type > b_type) {
                return 1
            } else if(a_type< b_type) {
                return -1
            } else {
                return 0
            }
        })
    },
    mounted: function() {
        // console.log('in mounted proteinSeq')
        this.setProteinSequenceAndPSites(this.sequence, this.modificationsSorted)
        this.createPtmMapping()
        this.renderProteinView()
        this.updatePlot()
    },
    watch: {
        selectedPtmTypes(newValue, oldValue) {
            // this.renderPtmSites()
            this.updatePlot()
        }
    },
    methods: {
        // TODO move to some kind of util module
        setModificationTypes: function(modList) {
            let modTypeList = []
            modList.forEach((element) => {
                const index = modTypeList.findIndex(mod => mod.text === element.modificationType)
                if (index !== -1) {
                    modTypeList[index].count++
                } else {
                    let temp = {
                        'text': element.modificationType,
                        'value': element.modificationType.replace(/ |,|-|\./g, '_').toLowerCase(),
                        'count': 1
                    }
                    modTypeList.push(temp)
                    temp = null
                }
            })
            // console.log(modTypeList)
            return modTypeList
        },
        setProteinSequenceAndPSites(sequence) {
            this.seqarray = sequence.split('')
        },
        renderProteinView() {
            this.initProteinBlock()

            this.createPtmSites()
            setTimeout(this.renderPtmSites(), 3000)

            this.createGradientDef()
            this.renderGradients()

            this.renderProteinSeq()

            this.createCompass()
        },
        initProteinBlock() {
            let margin = { top: 0, right: 40, bottom: 80, left: 40 },
                svg_width = document.getElementById('proteinBlock').offsetWidth,
                svg_height = 500
            this.chart_height = svg_height - margin.top - margin.bottom
            let moveXaxis = 0
            this.chart_width = svg_width - margin.left - margin.right
            let xMax = this.sequence.length,
                xMin = 1

            this.xScale = d3
                .scaleLinear()
                .range([0, this.chart_width])
                .nice()
                .domain([xMin, xMax])

            this.xAxis = d3.axisBottom(this.xScale)

            this.zoom = d3
                .zoom()
                .scaleExtent([1, (4 / 120) * this.sequence.length]) //1,50
                .translateExtent([
                    [0, 0],
                    [this.chart_width, this.chart_height]
                ])
                .on('zoom', this.zoomed)

            this.svg = d3
                .select('#proteinBlock')
                .append('svg')
                .attr('width', svg_width)
                .attr('height', svg_height)
                .style('background-color', 'white')
                .append('g')
                .attr(
                    'transform',
                    'translate(' + margin.left + ',' + margin.top + ')'
                )
            this.svg2 = this.svg
                .append('svg')
                .attr('width', this.chart_width)
                .attr('height', this.chart_height)
                .append('g')
                .call(this.zoom)
            let view = this.svg2
                .append('rect')
                .attr('width', this.chart_width)
                .attr('height', this.chart_height)
                .style('fill', 'white')

            let gX = this.svg
                .append('g')
                .classed('xAxis', true)
                .attr(
                    'transform',
                    'translate(0,' + (this.chart_height + moveXaxis) + ')'
                )
                .call(this.xAxis)

            let xAxisLabel = this.svg
                .append('text')
                .attr('class', 'x label')
                .attr('text-anchor', 'middle')
                .attr('x', this.chart_width / 2)
                .attr('y', this.chart_height + 30)
                .text('Protein Sequence')
                .style('font-size', '13px')
                .style('font-family', 'Arial')
        },
        renderProteinSeq() {
            this.proteinseq = this.svg2
                .append('g')
                .selectAll('text')
                .data(this.seqarray)
                .enter()
                .append('text')
                .attr('y', this.chart_height - 2)
                .text(function(d) {
                    return d
                })
                .attr('x', (d, i) => this.xScale(i + 1))
                .style('font-size', '13px')
                .style('x', '5')
                .attr('text-anchor', 'middle')
                .attr('visibility', 'hidden')
        },
        createCompass() {
            this.svg
                .append('circle')
                .attr('cx', this.chart_width - 64)
                .attr('cy', 15)
                .attr('r', 10)
                .style('fill', 'white')
                .style('stroke', '#666666')
                .style('stroke-width', '1')
                .on('mouseover', function() {
                    d3.select(this).style('fill', '#bdbdbd')
                })
                .on('mouseout', function() {
                    d3.select(this).style('fill', 'white')
                    //tipMut.hide(d)
                })
                .on('click', this.applyReset)

            this.svg
                .append('circle')
                .attr('class', 'designInButton')
                .attr('cx', this.chart_width - 64)
                .attr('cy', 15)
                .attr('r', 3)
                .style('fill', 'none')
                .style('stroke', '#666666')
                .style('stroke-width', '2')

            this.svg
                .append('circle')
                .attr('cx', this.chart_width - 42)
                .attr('cy', 15)
                .attr('r', 10)
                .style('fill', 'white')
                .style('stroke', '#666666')
                .style('stroke-width', '1')
                .on('mouseover', function() {
                    d3.select(this).style('fill', '#bdbdbd')
                })
                .on('mouseout', function() {
                    d3.select(this).style('fill', 'white')
                    // tipMut.hide(d)
                })
                .on('click', this.zoomINbuttonAction)

            this.svg
                .append('line')
                .attr('class', 'designInButton')
                .attr('stroke-width', 2)
                .attr('stroke', '#666666')
                .attr('x1', this.chart_width - 46)
                .attr('y1', 15)
                .attr('x2', this.chart_width - 38)
                .attr('y2', 15)

            this.svg
                .append('line')
                .attr('class', 'designInButton')
                .attr('stroke-width', 2)
                .attr('stroke', '#666666')
                .attr('x1', this.chart_width - 42)
                .attr('y1', 11)
                .attr('x2', this.chart_width - 42)
                .attr('y2', 19)

            this.svg
                .append('circle')
                .attr('cx', this.chart_width - 86)
                .attr('cy', 15)
                .attr('r', 10)
                .style('fill', 'white')
                .style('stroke', '#666666')
                .style('stroke-width', '1')
                .on('mouseover', function() {
                    d3.select(this).style('fill', '#bdbdbd')
                })
                .on('mouseout', function() {
                    d3.select(this).style('fill', 'white')
                    // tipMut.hide(d)
                })
                .on('click', this.zoomOUTbuttonAction)

            this.svg
                .append('line')
                .attr('class', 'designInButton')
                .attr('stroke-width', 2)
                .attr('stroke', '#666666')
                .attr('x1', this.chart_width - 90)
                .attr('y1', 15)
                .attr('x2', this.chart_width - 82)
                .attr('y2', 15)

            let panLeftx = this.chart_width - 118
            this.svg
                .append('path')
                .attr('d', 'M' + panLeftx + ' 14 l20 -12 a100,40 0 0,0 0,24z')
                .style('fill', 'white')
                .style('stroke', '#666666')
                .style('stroke-width', '1')
                .on('mouseover', function() {
                    d3.select(this).style('fill', '#bdbdbd')
                })
                .on('mouseout', function() {
                    d3.select(this).style('fill', 'white')
                    //  tipMut.hide(d)
                })
                .on('click', this.panLeftbuttonAction)

            let panRightx = this.chart_width - 10 ///2 + 54
            this.svg
                .append('path')
                .attr('d', 'M' + panRightx + ' 14 l-20 -12 a100,40 0 0,1 0,24z')
                .style('fill', 'white')
                .style('stroke', '#666666')
                .style('stroke-width', '1')
                .on('mouseover', function() {
                    d3.select(this).style('fill', '#bdbdbd')
                })
                .on('mouseout', function() {
                    d3.select(this).style('fill', 'white')
                    //  tipMut.hide(d)
                })
                .on('click', this.panRightbuttonAction)
        },
        updatePlot() {
            // console.log('update d3', d3)
            // For each check box:
            this.modificationTypes.forEach(el => {
                if (this.selectedPtmTypes.includes(el.value)) {
                    this.svg2.selectAll('.' + el.value)
                        .transition()
                        .duration(1000)
                        .style("opacity", 1)
                } else {
                    this.svg2.selectAll('.' + el.value)
                        .transition()
                        .duration(1000)
                        .style("opacity", 0)
                }
            })
        },

        createPtmSites() {
            this.ptmSitesGroup = this.svg2.append('g').attr('id', 'circles')
        },

        renderPtmSites() {
            // console.log('renderPtmSites')
            let occupied = []
            // this.ptmSites = this.ptmSitesGroup.selectAll('.site')
            //     .data(this.modificationsSorted.filter(m => {
            //         return this.selectedPtmTypes.includes(m.modificationType.replace(/ |,|-|\./g, '_').toLowerCase())
            //     }))
            this.ptmSites = this.ptmSitesGroup.selectAll('.site').data(
                this.modificationsSorted.filter(
                    m => this.ptmMap[m.modificationName].show
                ),
                d => this.modificationsSorted.indexOf(d)
            )
            this.ptmSites
                .transition()
                .select('circle')
                .attr('cy', d => placeSite(d))

            var newPtmSites = this.ptmSites
                .enter()
                .append('g')
                .classed('site', true)
            let tooltip = d3
                .select('body')
                .append('div')
                .attr('class', 'tooltip-protein-sequence')
                .style('opacity', 0)
            newPtmSites
                .append('circle')
                .attr('r', 4)
                .attr('cx', d => this.xScale(d.uniprotPosition))
                .attr('cy', d => placeSite(d))
                .attr('class', d => {return d.modificationType.replace(/ |,|\.|-/g, '_').toLowerCase()})
                .style(
                    'fill',
                    d => legendColours[d.modificationType]
                )
                .style('stroke', d => legendColours[d.modificationType])
                .style('stroke-width', '2')
                .on('mouseover', (event, d) => {
                    if(this.selectedPtmTypes.includes(this.formatModificationType(d.modificationType))) {
                        tooltip.transition()
                            .duration(200)
                            .style('opacity', 0.9)
                        tooltip
                            .style('left', event.pageX + 'px')
                            .style('top', event.pageY - 28 + 'px')
                            // .style('background-color', '#FFFFFF')
                            .html('<p> Modified residue: ' + d.modifiedResidue + '<br />' + 
                                d.modificationType + ': ' + d.unimodModificationName +'<br/>' +
                                'Source: ' + d.source + '<br />' +
                                'Unimod ID: ' + d.unimodId + '<br/>' +
                                'UP position: ' + d.uniprotPosition + '<br/></p>'
                            )
                    }
                })
                .on('mouseout', function(d) {
                    tooltip.transition()
                        .duration(500)
                        .style('opacity', 0)
                })

            this.ptmSites.exit().remove()
            this.ptmSites = newPtmSites.merge(this.ptmSites)

            /**
             * Places ptm sites vertically underneath each other.
             *
             * @return y coordinate
             */
            function placeSite(d) {
                if (
                    occupied[d.uniprotPosition] === undefined ||
                    occupied[d.uniprotPosition] === 0
                ) {
                    occupied[d.uniprotPosition] = 1
                } else {
                    occupied[d.uniprotPosition]++
                }
                var ptm_num = occupied[d.uniprotPosition]
                return 400 - (ptm_num - 1) * 10
            }
        },
        formatModificationType(modType) {
            return modType.replace(/ |,|\.|-/g, '_').toLowerCase()
        },
        /**
         * Assign a color and visibility status to every type of PTM in the
         * modifications list
         */
        createPtmMapping() {
            this.ptmTypes = [
                ...new Set(this.modificationsSorted.map(x => x.modificationName))
            ]
            
            let colorMap = this.getColorMap(this.ptmTypes)

            for (let ptm in this.ptmTypes) {
                let ptmType = this.ptmTypes[ptm]
                this.ptmMap[ptmType] = {
                    show: true,
                    color: colorMap[ptmType]
                }
            }
        },

        /**
         * Keeps ptm color codings consistent within a page.
         */
        getColorMap(ptmTypes) {
            let colorMapping = {}
            if (Object.keys(colorMapping).length == 0) {
                for (var ptm in ptmTypes) {
                    colorMapping[ptmTypes[ptm]] =
                        colorScheme[ptm % colorScheme.length]
                }
            }
            return colorMapping
        },

        createGradientDef() {
            this.gradDefs = this.svg2.append('defs')
        },

        renderGradients() {
            let gradients = this.gradDefs.selectAll('linearGradient').data(
                this.modificationsSorted.filter(
                    m => this.ptmMap[m.modificationName].show
                ),
                d => this.modificationsSorted.indexOf(d)
            )

            gradients
                .enter()
                .append('linearGradient')
                .attr('id', d => 'grad_' + this.modificationsSorted.indexOf(d))
                .attr('x1', '0%')
                .attr('x2', '0%')
                .attr('y1', '100%')
                .attr('y2', '0%')
                .each(this.setGrad)

            gradients.exit().remove()
        },
        setGrad(d) {
            let grad = d3.select('linearGradient')
            let colorSize = 0
            if (this.maxPeptideCount > 0) {
                colorSize = (d.peptides.length * 100) / this.maxPeptideCount
            }
            let ptmColor = this.ptmMap[d.modificationName]['color']

            grad.append('stop')
                .attr('offset', colorSize + '%')
                .style('stop-color', ptmColor)
            grad.append('stop')
                .attr('offset', colorSize + '%')
                .style('stop-color', 'white')

            if (colorSize == 100) {
                grad.append('stop')
                    .attr('offset', colorSize + '%')
                    .style('stop-color', 'white')
            } else {
                grad.append('stop')
                    .attr('offset', 100 + '%')
                    .style('stop-color', 'white')
            }
        },
        applyReset() {
            this.svg2
                .transition()
                .duration(2000)
                .call(this.zoom.transform, d3.zoomIdentity)
        },
        zoomINbuttonAction() {
            this.svg2
                .transition()
                .duration(200)
                .call(this.zoom.scaleBy, 1.5)
            //zoom.scaleBy(svg2, 1.5)
        },
        zoomOUTbuttonAction() {
            this.svg2
                .transition()
                .duration(200)
                .call(this.zoom.scaleBy, 0.66)
            //zoom.scaleBy(svg2, 0.66)
        },
        panLeftbuttonAction() {
            this.svg2
                .transition()
                .duration(500)
                .call(
                    this.zoom.translateBy,
                    (10 * 1200) / this.sequence.length,
                    0
                )
        },
        panRightbuttonAction() {
            this.svg2
                .transition()
                .duration(500)
                .call(
                    this.zoom.translateBy,
                    (-10 * 1200) / this.sequence.length,
                    0
                )
            // zoom.translateBy(svg2, -10, 0)
        },
        zoomed(event) {
            this.svg
                .select('.xAxis')
                .call(this.xAxis.scale(event.transform.rescaleX(this.xScale)))
            let new_xScale = event.transform.rescaleX(this.xScale)
            this.ptmSites.selectAll('circle').attr('cx', function(d) {
                return new_xScale(d.uniprotPosition)
            })
            this.proteinseq.attr('x', function(d, i) {
                return new_xScale(i + 1)
            })
            if (new_xScale.domain()[1] - new_xScale.domain()[0] >= 100) {
                this.proteinseq.attr('visibility', 'hidden')
            } else {
                this.proteinseq.attr('visibility', 'visible')
            }
        }
    }
}
</script>
<style lang="scss">
.tooltip-protein-sequence {
    position: absolute;
    text-align: left;
    width: auto;
    height: auto;
    padding: 2px;
    font-size: 12px;
    background: lightsteelblue;
    border: 1px solid black;
    border-radius: 3px;
    pointer-events: none;
}
</style>
